module.exports = __webpack_public_path__ + "static/media/eg3.c4790215.webp";